import { render, staticRenderFns } from "./DetailsDevice.vue?vue&type=template&id=dbd4fd2e&"
import script from "./DetailsDevice.vue?vue&type=script&lang=js&"
export * from "./DetailsDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports